export const parsePinnedProjectIds = (value: string | null): string[] => {
  if (!value) {
    return [];
  }
  try {
    const parsed = JSON.parse(value) as unknown;
    if (!Array.isArray(parsed)) {
      return [];
    }
    return [
      ...new Set(
        parsed.filter(
          (id): id is string => typeof id === 'string' && id.length > 0,
        ),
      ),
    ];
  } catch {
    return [];
  }
};

export const partitionPinnedProjects = <T extends { id: string }>(
  projects: T[],
  pinnedIds: string[],
): { pinned: T[]; others: T[] } => {
  const pinned = new Set(pinnedIds);
  return {
    pinned: projects.filter((project) => pinned.has(project.id)),
    others: projects.filter((project) => !pinned.has(project.id)),
  };
};
